import { render, staticRenderFns } from "./receipt-card-package-info.vue?vue&type=template&id=40b4f70e"
import script from "./receipt-card-package-info.vue?vue&type=script&lang=js"
export * from "./receipt-card-package-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports